var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.77901V21.1604C0 21.4307 0.21875 21.6494 0.48897 21.6494H15.1066C15.3768 21.6494 15.5956 21.4307 15.5956 21.1604V9.77901C15.5956 9.50879 15.3768 9.29004 15.1066 9.29004H0.48897C0.21875 9.29004 0 9.50879 0 9.77901ZM9.29044 18.4454H6.30514L6.92279 14.9003C6.47242 14.6108 6.17003 14.1025 6.17003 13.5299C6.17003 12.6292 6.89706 11.9022 7.79779 11.9022C8.69853 11.9022 9.42555 12.6292 9.42555 13.5299C9.42555 14.109 9.12316 14.6108 8.67279 14.9003L9.29044 18.4454Z",
    fill: "#FFF057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8265 9.29044H11.8192V6.02849C11.8192 3.80882 10.0113 2.00735 7.79802 2.00735C5.58479 2.00735 3.77688 3.81526 3.77688 6.02849V9.29044H1.76953V6.02849C1.76953 2.7022 4.47174 0 7.79802 0C11.1243 0 13.8265 2.7022 13.8265 6.02849V9.29044Z",
    fill: "#FFF057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.803b69bf58a48ee7c2d9fb4793187d88.svg";
export { ForwardRef as ReactComponent };